import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    marginTop: 0,
    marginBottom: 0,
  },

  primary: {
    color: idsTokens.listItem.default.color.text.label.enabled,
    fontSize: idsTokens.typography.font.size.base,
    fontStyle: 'normal',
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.lg,

    '.MuiListItem-root:focus &, .MuiListItem-root.Mui-focused &': {
      color: idsTokens.listItem.default.color.text.label.focus,
    },
    '.MuiListItem-root:hover &': {
      color: idsTokens.listItem.default.color.text.label.hover,
    },
    '.MuiListItem-root:active &': {
      color: idsTokens.listItem.default.color.text.label.pressed,
    },
    '.MuiListItem-root[disabled] &, .MuiListItem-root[aria-disabled="true"] &, .MuiListItem-root.Mui-disabled &': {
      color: idsTokens.listItem.default.color.text.label.disabled,
    },

    '.MuiListItem-root.Miu-error:focus &, .MuiListItem-root.Miu-error.Mui-focused &': {
      color: idsTokens.listItem.error.color.text.label.focus,
    },
    '.MuiListItem-root.Miu-error:hover &': {
      color: idsTokens.listItem.error.color.text.label.hover,
    },
    '.MuiListItem-root.Miu-error:active &': {
      color: idsTokens.listItem.error.color.text.label.pressed,
    },
    '.MuiListItem-root.Miu-error[disabled] &, .MuiListItem-root.Miu-error[aria-disabled="true"] &, .MuiListItem-root.Miu-error.Mui-disabled &': {
      color: idsTokens.listItem.error.color.text.label.disabled,
    },
  },

  secondary: {
    color: idsTokens.listItem.default.color.text.sub.enabled,
    fontSize: idsTokens.typography.font.size.sm,
    fontStyle: 'normal',
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight.sm,
    letterSpacing: idsTokens.typography.spacing.letter.md,

    '.MuiListItem-root:focus &, .MuiListItem-root.Mui-focused &': {
      color: idsTokens.listItem.default.color.text.sub.focus,
    },
    '.MuiListItem-root:hover &': {
      color: idsTokens.listItem.default.color.text.sub.hover,
    },
    '.MuiListItem-root:active &': {
      color: idsTokens.listItem.default.color.text.sub.pressed,
    },
    '.MuiListItem-root[disabled] &, .MuiListItem-root[aria-disabled="true"] &, .MuiListItem-root.Mui-disabled &': {
      color: idsTokens.listItem.default.color.text.sub.disabled,
    },

    '.MuiListItem-root.Miu-error:focus &, .MuiListItem-root.Miu-error.Mui-focused &': {
      color: idsTokens.listItem.error.color.text.sub.focus,
    },
    '.MuiListItem-root.Miu-error:hover &': {
      color: idsTokens.listItem.error.color.text.sub.hover,
    },
    '.MuiListItem-root.Miu-error:active &': {
      color: idsTokens.listItem.error.color.text.sub.pressed,
    },
    '.MuiListItem-root.Miu-error[disabled] &, .MuiListItem-root.Miu-error[aria-disabled="true"] &, .MuiListItem-root.Miu-error.Mui-disabled &': {
      color: idsTokens.listItem.error.color.text.sub.disabled,
    },
  },
});
